"use client"

import { useEffect } from "react"

export function ErrorTracker() {
    useEffect(() => {
        let cleanups: (() => void)[] = [];
        let idleId: number;
        let timerId: NodeJS.Timeout;

        const initTrackers = () => {
            const handleError = async (event: ErrorEvent) => {
                try {
                    const errorData = {
                        reason: event.message,
                        context: window.location.href,
                        stack_trace: event.error?.stack || "No stack trace available",
                        user_agent: navigator.userAgent,
                    }

                    await fetch("/api/analytics/bug", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(errorData),
                    })
                } catch (err) {
                    console.error("Bug Tracker failed to log error:", err)
                }
            }

            const handleRejection = async (event: PromiseRejectionEvent) => {
                try {
                    const errorData = {
                        reason: `Unhandled Rejection: ${event.reason}`,
                        context: window.location.href,
                        stack_trace: event.reason?.stack || "No stack trace available",
                        user_agent: navigator.userAgent,
                    }

                    await fetch("/api/analytics/bug", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(errorData),
                    })
                } catch (err) {
                    console.error("Bug Tracker failed to log rejection:", err)
                }
            }

            window.addEventListener("error", handleError)
            window.addEventListener("unhandledrejection", handleRejection)

            cleanups.push(() => {
                window.removeEventListener("error", handleError)
                window.removeEventListener("unhandledrejection", handleRejection)
            });
        }

        if (typeof window !== "undefined" && "requestIdleCallback" in window) {
            idleId = window.requestIdleCallback(() => {
                initTrackers();
            });
        } else {
            timerId = setTimeout(initTrackers, 200);
        }

        return () => {
            if (idleId && typeof window !== "undefined" && "cancelIdleCallback" in window) {
                window.cancelIdleCallback(idleId);
            }
            if (timerId) {
                clearTimeout(timerId);
            }
            cleanups.forEach(fn => fn());
        }
    }, [])

    return null
}
